import * as countries from 'i18n-iso-countries';
// Register German locale for i18n-iso-countries
import german_locale from 'i18n-iso-countries/langs/de.json';

import { SelectionOption } from '@/models/SelectionOption.ts';

countries.registerLocale(german_locale);

export const countryCodeToGermanName = (code: string | undefined): string | undefined => {
    if (!code) return undefined;
    return countries.getName(code, 'de');
};

export const getCountryOptions = (is_dach_countries_only?: boolean): Array<SelectionOption> => {
    const country_names = countries.getNames('de', { select: 'official' });

    let filtered_countries = Object.entries(country_names);

    // If limited countries is requested (e.g., for Datacur), only show DACH countries
    if (is_dach_countries_only) {
        const allowed_codes = new Set(['DE', 'CH', 'AT']); // Germany, Switzerland, Austria (DACH region)
        filtered_countries = filtered_countries.filter(([code]) => allowed_codes.has(code));
    }

    return filtered_countries
        .map(([code, name]) => ({
            value: code,
            label: name,
        }))
        .sort((a, b) => a.label.localeCompare(b.label, 'de'));
};
